import { render, staticRenderFns } from "./ObjectListTab.vue?vue&type=template&id=365f8eeb&scoped=true&"
import script from "./ObjectListTab.vue?vue&type=script&lang=js&"
export * from "./ObjectListTab.vue?vue&type=script&lang=js&"
import style0 from "./ObjectListTab.vue?vue&type=style&index=0&id=365f8eeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f8eeb",
  null
  
)

export default component.exports